import React from 'react';
import { BookOpenIcon, WrenchScrewdriverIcon, BookmarkIcon, MicrophoneIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

const articles = [
  {
    title: 'The Shape of Story – Eleganthack',
    description: 'A visual and conceptual guide to story structure.',
    url: 'https://eleganthack.com/the-shape-of-story/?utm_source=substack&utm_medium=email'
  },
  {
    title: 'The Art of Data Storytelling – HBR',
    description: 'Harvard Business Review on the importance and methods of data storytelling.',
    url: 'https://online.hbs.edu/blog/post/data-storytelling'
  },
  {
    title: 'How to be a great story-teller – Claire Wang',
    description: 'Practical advice for becoming a better data storyteller.',
    url: 'https://medium.com/swlh/how-to-be-a-great-data-storyteller-d5d01e891e97'
  },
  {
    title: '8 classic storytelling techniques',
    description: 'A summary of classic storytelling frameworks and how to use them.',
    url: 'https://norsensus.no/storydown/storytelling-techniques/'
  }
];

const tools = [
  {
    title: 'People Metrics Benchmarking',
    description: 'Startup-specific benchmarks for 19 People & Talent metrics.',
    url: 'http://peoplemetrics.fyi'
  },
  {
    title: '7 Types Of Stories You Can Tell in Business – GoNarrative',
    description: 'A guide to universal story types in business.',
    url: 'https://www.gonarrative.com/business-storytelling-blog/the-seven-universal-story-types-what-they-are-and-which-one-to-tell-right-now'
  },
  {
    title: 'The And, But, Therefore (ABT) Framework',
    description: 'A simple, powerful framework for structuring stories.',
    url: 'https://entomologychallenges.org/wp-content/uploads/2018/10/abt-shorthand-reference-card.pdf'
  }
];

const templates = [
  {
    title: 'The Listening Tour Playbook – Tova Soroka (Medium)',
    description: 'A practical playbook for running listening tours.',
    url: 'https://medium.com/@tova.soroka/a-listening-tour-playbook-af3b64e5aa26'
  },
  {
    title: 'Listening Tour Playbook (Notion)',
    description: 'A Notion template for structuring a listening tour.',
    url: 'https://www.notion.so/Listening-Tour-Playbook-e1d5d0aa790b4af883bf6f5072142b05?pvs=21'
  },
  {
    title: 'Pixar Storytelling Rules',
    description: "Pixar's famous 22 rules for great storytelling.",
    url: 'https://www.aerogrammestudio.com/2013/03/07/pixars-22-rules-of-storytelling/'
  },
  {
    title: 'Storytelling tactics PIP deck',
    description: 'A deck of cards with practical storytelling tactics.',
    url: 'https://pipdecks.com/pages/dans-copy-of-storyteller-tactics-card-deck?tw_source=google&tw_adid=&tw_campaign=21102535378&gad_source=1&gclid=CjwKCAjwi_exBhA8EiwA_kU1Ml9etr8DevdWgclvo_FHYbM-FGCh31W6oRKATSfpj0XJFvx1rVn2VxoCMT8QAvD_BwE'
  }
];

const podcasts = [
  {
    title: 'The importance of storytelling in people analytics – Cole Nussbaumer Knaflic (Spotify)',
    description: 'Podcast episode on storytelling in people analytics.',
    url: 'https://open.spotify.com/episode/3FEE3TpCeFrPi7EVnkSha8?si=wU8qcZp4T6SbqxlevX72PQ'
  }
];

const StorytellingWithDataUsefulResources = () => (
  <div className="space-y-8">
    <PlaybookSection title="Useful Resources" icon={<BookOpenIcon className="h-7 w-7 text-primary-light" />} heading>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <PlaybookCard>
          <ResourceList 
            title="Articles & Guides" 
            items={articles} 
            icon={BookOpenIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Tools & Frameworks" 
            items={tools} 
            icon={WrenchScrewdriverIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Templates & Examples" 
            items={templates} 
            icon={BookmarkIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Podcasts & Media" 
            items={podcasts} 
            icon={MicrophoneIcon}
          />
        </PlaybookCard>
      </div>
    </PlaybookSection>
  </div>
);

export default StorytellingWithDataUsefulResources; 